// job offer statuses
export const STATUS_PROCESSING = 'PROCESSING';
export const STATUS_DRAFT = 'DRAFT';
export const STATUS_ERROR = 'ERROR';
export const STATUS_PUBLISHED = 'PUBLISHED';
